import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const GridEvents: AnalyticsBrandSettings = {

  /** Clic en el botón "Filtrar" */
  parrillaCatalogoAbrirFiltro(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'abrir_filtro');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  parrillaCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'parrilla', 'anadir_producto_cesta', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['16', '17', '198', '20', '48', '58', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  parrillaWishlistAnadirProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'parrilla', 'anadir_producto_wishlist', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['16', '17', '198', '20', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaWishlistEliminarProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'parrilla', 'eliminar_producto_wishlist', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoAplicarFiltro(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'parrilla', 'aplicar_filtro', componentData?.selectedFilter
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['78'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoCambioVista(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const numberProducts = componentData?.numColumns;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'parrilla', 'cambio_vista', numberProducts?.toString()
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['19'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoClickCategoria(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const url = AnalyticsEcommerceHelpersOysho.parseUrl(componentData.url);

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'click_categoria', url);
    const settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    return settingsGTM;
  },

  parrillaCatalogoClickCategoriaDestacada(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const url = AnalyticsEcommerceHelpersOysho.parseUrl(componentData.url);

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'click_categoria_destacada', url);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['46'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaNavegacionClickBreadcrumb(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const url = AnalyticsEcommerceHelpersOysho.parseUrl(componentData.url);

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'parrilla', 'click_breadcrumb', url);
    const settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    return settingsGTM;
  },

  parrillaCatalogoLimpiarFiltro(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'parrilla', 'limpiar_filtro', componentData.selectedFilter
    );
    const settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    return settingsGTM;
  },

  parrillaCatalogoSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'seleccionar_color', label);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['20', '48'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'seleccionar_talla', label);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoSeleccionarLargo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'seleccionar_talla', label);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['20', '14'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  parrillaCatalogoVerBundle(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'parrilla', 'ver_bundle', product?.fullReference
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  parrillaCatalogoVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'ver_producto', partnumber);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['100', '101', '117', '15', '20', '46', '47', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  parrillaCatalogoVerVistaRapidaProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'parrilla', 'ver_vista_rapida_producto', partnumber
    );
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['100', '101', '117', '20', '47', '70', '98', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  parrillaCatalogoVerFotoAuxiliar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-${componentData?.carouselSlide}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'ver_foto_auxiliar', label);
    let settingsGTM = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string[] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  // TODO: Emitir evento cuando se añadan banners promocionales en parrilla
  parrillaCatalogoClickBanner(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const url = AnalyticsEcommerceHelpersOysho.parseUrl(componentData.url);
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'parrilla', 'click_banner', url);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};